import { render, staticRenderFns } from "./SttrN_Items.vue?vue&type=template&id=4a8b3f6c"
import script from "./SttrN_Items.vue?vue&type=script&lang=js"
export * from "./SttrN_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports